import { createContext, useContext, useState, ReactNode } from "react";

interface ConsultationDrawerContextType {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

const ConsultationDrawerContext = createContext<ConsultationDrawerContextType | undefined>(undefined);

export const ConsultationDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <ConsultationDrawerContext.Provider value={{
      isOpen,
      openDrawer: () => setIsOpen(true),
      closeDrawer: () => setIsOpen(false),
    }}>
      {children}
    </ConsultationDrawerContext.Provider>
  );
};

export const useConsultationDrawer = () => {
  const context = useContext(ConsultationDrawerContext);
  if (!context) {
    throw new Error("useConsultationDrawer must be used within ConsultationDrawerProvider");
  }
  return context;
};
